



















import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import BillingPlanOverview from '@/componentsV2/molecules/BillingPlanOverview/BillingPlanOverview.vue';

@Component({
  components: {
    Typography,
    BillingPlanOverview
  }
})
export default class Overview extends Vue {
  @Prop() subscription!: any;

  get tPrefix() {
    return 'modals.billing.reactivation.overview';
  }
}
